/* eslint-disable react/prop-types */
import { SkipToContent as CarbonSkipToContent } from '@carbon/react';

export const SkipToContent = ({ children, ...props }) => (
  <CarbonSkipToContent {...props}>{children}</CarbonSkipToContent>
);
